import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiErrorResponse } from '../models';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    /* This is a function that is called when an error occurs. */
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                const customError: ApiErrorResponse = {
                    success: false,
                    errorCode: '',
                    message: '',
                    timestamp: new Date().toISOString(),
                    path: request.url,
                };

                // Offline
                if (!navigator.onLine) {
                    customError.errorCode = 'network_error';
                    customError.message = 'No Internet Connection';
                }

                // Backend unreachable
                else if (error.status === 0) {
                    customError.errorCode = 'connection_error';
                    customError.message = 'Unable to connect to server';
                }

                // Validation / API-defined error
                else if (error.error) {
                    customError.errorCode = error.error.errorCode || 'business_error';
                    customError.message = error.error.message || 'An error occurred.';

                    // Handle validation errors (field-level)
                    if (error.error.errors && typeof error.error.errors === 'object') {
                        customError.errors = error.error.errors;
                    }
                }

                // Fallback
                else {
                    customError.errorCode = 'unexpected_error';
                    customError.message = 'An unexpected error occurred.';
                }

                return throwError(() => customError);
            }),
        );
    }
}
